import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    redirect: "/statement/projects",
    children: [
      {
        path: "/statement/projects",
        name: "Project",
        component: () => import("../views/Project.vue"),
      },
      {
        path: "/statement/projects/detail",
        name: "ProjectDetail",
        component: () => import("../views/ProjectDetail.vue"),
      },
      {
        path: "/users/list",
        name: "User",
        component: () => import("../views/User.vue"),
      },
      {
        path: "/users/detail",
        name: "UserDetail",
        component: () => import("../views/UserDetail.vue"),
      },
      {
        path: "/statement/list",
        name: "Statement",
        component: () => import("../views/Statement.vue"),
      },
      {
        path: "/statement/detail",
        name: "StatementDetail",
        component: () => import("../views/StatementDetail.vue"),
      },
      {
        path: "/cargos",
        name: "Cargos",
        component: () => import("../views/Cargos.vue"),
      },
      {
        path: "/suppliers",
        name: "Suppliers",
        component: () => import("../views/Suppliers.vue"),
      },
      {
        path: "/receivers",
        name: "Receivers",
        component: () => import("../views/Receivers.vue"),
      },
      {
        path: "/customers",
        name: "Customers",
        component: () => import("../views/Customers.vue"),
      },
      {
        path: "/budget/verifiers",
        name: "BudgetVerifiers",
        component: () => import("../views/BudgetVerifiers.vue"),
      },
      {
        path: "/final/verifiers",
        name: "FinalVerifiers",
        component: () => import("../views/FinalVerifiers.vue"),
      },
      {
        path: "/verifiers/statements",
        name: "VerifyStatement",
        component: () => import("../views/VerifyStatement.vue"),
      },
      {
        path: "/recive/accounts",
        name: "ReciveAccounts",
        component: () => import("../views/ReciveAccounts.vue"),
      },
      {
        path: "/payment/accounts",
        name: "PaymentAccounts",
        component: () => import("../views/PaymentAccounts.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
